import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSiteContent } from "../context/SiteContentContext";
import { EventsSection } from "../components/EventsSection";
import { EventGallery } from "../components/EventGallery";

export default function WhatWeDoPage() {
  const { focusAreas, events, gallery } = useSiteContent();
  return (
    <div data-testid="what-we-do-page">
      <section className="pt-32 md:pt-44 pb-12">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
          <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">What we do</p>
          <div className="mt-6 grid lg:grid-cols-12 gap-10 items-end">
            <h1 className="lg:col-span-8 font-display text-black text-5xl md:text-7xl lg:text-[100px] leading-[0.9] tracking-tight">
              Current services,<br /><span className="italic text-[#EC4899]">Case studies.</span>
            </h1>
            {/* <p className="lg:col-span-4 text-lg text-black/70 leading-relaxed">
            Explore our inspiring case studies that showcase how we empower individuals through work experience, confidence building, mentoring and essential life skills . Stories of personal growth and transformation.            </p> */}
          </div>
        </div>
      </section>

      {/* FOCUS AREAS – alternating */}
      {focusAreas.map((f, i) => (
        <section key={f.id || `${f.title}-${i}`} data-testid={`focus-${i}`} className={`py-20 md:py-24 ${i % 2 === 1 ? "bg-[#FDF2F8]" : ""}`}>
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-10 items-center">
            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="rounded-[32px] overflow-hidden aspect-[5/4] shadow-ambient bg-[#FDF2F8]">
                {f.image ? (
                  <img src={f.image} alt={f.title} className="w-full h-full object-cover" />
                ) : null}
              </div>
            </div>
            <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <div className="font-mono text-sm text-[#EC4899] tracking-widest">0{i + 1} / 0{focusAreas.length}</div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black mt-4 leading-[0.95]">{f.title}</h2>
              {f.text ? <p className="mt-6 text-black/70 text-lg leading-relaxed">{f.text}</p> : null}
              {Array.isArray(f.bullets) && f.bullets.length > 0 && (
                <ul className={`space-y-3 text-black/70 text-lg leading-relaxed ${f.text ? "mt-4" : "mt-6"}`}>
                  {f.bullets.map((item) => (
                    <li key={item} className="flex gap-3">
                      <span className="mt-[0.7rem] h-1.5 w-1.5 shrink-0 rounded-full bg-[#EC4899]" aria-hidden />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
              <Link to="/services" data-testid={`focus-cta-${i}`} className="mt-8 inline-flex items-center gap-2 text-black font-medium border-b border-[#EC4899] pb-1 hover:gap-3 transition-all">
                See related programmes <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </section>
      ))}

      <EventsSection events={events} />

      <EventGallery images={gallery} />

      {/* CTA */}
      <section className="px-6 md:px-10 lg:px-14 pb-24">
        <div className="max-w-[1440px] mx-auto rounded-[40px] p-12 md:p-20 bg-white border border-black/10 text-center">
          <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">Want to get involved?</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black mt-4 leading-tight">Bringing people together through creativity, education, and conversations.</h2>
          <Link to="/contact" data-testid="wwd-cta" className="mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#EC4899] text-white font-medium hover:bg-[#DB2777] transition-all hover:-translate-y-[2px] shadow-pink">
            Start a conversation <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
